import React, { useState } from 'react';
import { DateInput, DateValue } from '@mantine/dates';
import styles from './DateTextField.module.css';

interface DateTextFieldProps {
  label?: string;
  value: DateValue;
  error: boolean;
  required: boolean;
  onChange: (value: DateValue) => void;
  onBlur?: (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
}

const DateTextField = ({
  label = 'Date',
  value,
  error = false,
  required = false,
  onChange,
  onBlur,
}: DateTextFieldProps) => {
  const [focused, setFocused] = useState(false);
  const floating = value !== null || focused || undefined;
  return (
    <DateInput
      classNames={styles}
      label={label}
      value={value}
      error={error}
      required={required}
      onChange={(value) => {
        onChange(value);
      }}
      onBlur={(e) => {
        onBlur?.(e);
      }}
      data-floating={floating}
      labelProps={{ 'data-floating': floating }}
    />
  );
};

export default DateTextField;
